<template>
	<div class="figure-box">
		<Breadcrumb :crumb="crumb"></Breadcrumb>
		<div class="figure">
			<div class="left">
				<div class="item-box">
					<div>
						<Button size="small" type="text" to="http://mallapi.xingjuju.com/template.xlsx" target="_blank"><Icon type="md-cloud-download" />模板下载</Button>
						<Upload :action="upload_url" :show-upload-list="false" :before-upload="handleBefore" :on-success="handleSuccess">
							<Button size="small" type="text"><Icon type="md-cloud-upload" />量体上传</Button>
						</Upload>
					</div>
					<div class="title flex align-center justify-between">
						<span>客户信息</span>
					</div>
					<Table
							ref="table"
							height="600"
							border
							size="default"
							:loading="loading"
							:columns="columns"
							:data="customer_list"
							@on-row-click="click"
					>
					</Table>
					<div class="pay" @click="go2checkout">量体完成，提交订单</div>

				</div>

			</div>
		</div>

	</div>

</template>

<script>
	import "@/env/.env.js"
	import {mapState} from 'vuex';
	import Breadcrumb from "@/components/Breadcrumb.vue";
	import {getFigureCustomers, checkFigureMobile, getFigureMeta, getBodyMeta} from "@/api"
	import {oss} from '@/utils/aliyunoss.js'
	import CalculatorManager from '@/utils/rule/Manager'
	export default {
		name: "GroupFigure",
		components: {
			Breadcrumb
		},
		data() {
			return {
				crumb: [{
					title: "团体定制",
					path: "group_category",
				}],
				upload_url: process.uniEnv.BASE_API + '/figure/group-customer-list',
				is_show_modal: false,
				uploadHost: '',
				uploadData: {},
				net_param_list: [],
				body_param_list: [],
				loading: false,
			};
		},
		computed: {
			...mapState({
				category: (state) => state.mtm.picked_category,
			}),
			customer_list() {
				return this.$store.state.mtm.form_data.group.customers || []
			},
			columns() {
				let result = []
				this.$store.state.mtm.form_data.group.column.forEach((item, index) => {
					result.push({
						title: item.field_name_cn,
						key: item.field_name_en,
						align: 'center',
						width: (index < 6) ? 80 : 110,
						fixed: (index < 6) ? 'left' : '-'
					})
				})

				return result
			}
		},
		watch: {

		},
		mounted() {
			this.$emit('showLogin', true)
			this.$emit('showBack', true)
			this.$emit('showNav', false)
			this.$emit('showFooter', true)
		},
		methods: {
			handleBefore() {
				this.loading = true
			},
			handleSuccess(response, file, fileList) {
				this.loading = false
				let excel_column = response.data.columns
				let customer_list = response.data.list
				this.$store.commit('mtm/update_group', {
					column: excel_column,
					customers: customer_list
				})
				// let quantity = customer_list.map(item => item.quantity).reduce((a,b) => parseInt(a)+parseInt(b))
				this.$store.commit('mtm/update_quantity', response.data.total)
			},
			go2checkout() {
				if(this.$store.state.mtm.form_data.group.customers.length <= 0) {
					this.$Notice.warning({
						title: `请选择客户`
					})
					return
				}
				this.$router.push({name: 'Checkout'})
			},
			click(data, index) {
				this.$refs.table.toggleSelect(index);
			}

		},
		filters: {
			}
	};
</script>

<style scoped lang="scss">
	.figure-box {
		width: 1170px;
		margin: 20px auto;
	}

	.figure {
		margin-top: 20px;
		margin-bottom: 50px;
	}

	.left {
		.item-box {
			width: 1170px;
			background: #ffffff;
			box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
			border-radius: 5px;
			padding: 20px;

			.body-box {
				margin: 20px 0;

				.body-item:nth-child(2n) {
					margin-left: 54px;
				}

				.body-item {
					float: left;
					display: flex;
					align-items: center;
					margin-bottom: 10px;

					.name {
						width: 58px;
						font-size: 14px;
						font-weight: bold;
						line-height: 59px;
					}

					.img-list {

						.img-box {
							text-align: center;
							float: left;
							margin-left: 10px;

							img {
								width: 100px;
								height: 100px;
								border-radius: 10px;
							}

							.value {
								font-size: 12px;
								font-weight: 400;
								color: #000000;
								margin-top: 5px;
							}
						}
					}
				}
			}

			textarea {
				height: 80px;
				background: #F3F4F5;
				opacity: 1;
				border-radius: 5px;
				padding: 10px;
				width: 100%;
				border: none;
				margin: 20px 0;
			}

			.title {
				height: 52px;
				line-height: 52px;
				border-bottom: 1px solid #e9e9e9;
				color: #0f114a;
				font-size: 16px;
				font-weight: bold;
			}

			.input-item-box {
				margin-top: 20px;
				display: flex;
				height: 42px;

				.input-item {
					display: flex;
					align-items: center;
				}

				.name {
					font-size: 15px;
					font-weight: bold;
					color: #000000;
					min-width: 30px;
				}

				.radio-box,
				input {
					width: 214px;
					height: 42px;
					border-bottom: 1px solid #dddddd;
					border-top: none;
					border-left: none;
					border-right: none;
					margin: 0 20px;
					padding-left: 10px;
				}
			}
		}
	}

	.right {
		margin-left: 30px;
		width: 270px;
		background: #ffffff;
		box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
		padding: 0 20px;
		float: left;
		.title {
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: bold;
			line-height: 22px;
			color: #000000;
			height: 52px;
			line-height: 52px;
			border-bottom: 1px solid #e9e9e9;
			text-align: center;
		}

		.goods {
			padding-top: 10px;
			display: flex;

			img {
				width: 80px;
				height: 80px;
			}

			.content {
				margin-left: 10px;

				.p-name {
					font-size: 15px;
					font-weight: bold;
					color: #000000;
					height: 60px;
				}

				.number-box {
					height: 20px;
					border: 1px solid #999999;
					display: flex;
					align-items: center;

					.minus,
					.plus {
						width: 27px;
						cursor: pointer;
						color: #707070;
						line-height: 27px;
						text-align: center;
						font-size: 18px;
					}

					.num {
						border-top: none;
						border-bottom: none;
						border-left: 1px solid #999999;
						border-right: 1px solid #999999;
						width: 27px;
						text-align: center;
						color: #000000;
					}
				}
			}
		}

		.order {
			padding-bottom: 10px;

			.main-color {
				font-size: 16px;
				font-weight: bold;
				color: #0f114a;
				margin: 20px 0 10px;
			}

			.item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #dddddd;
				height: 44px;

				span.label {
					width: 60px;
					font-size: 13px;
					font-weight: bold;
					color: #333333;
					text-align: right;
				}

				.value {
					font-weight: 400;
					color: #666666;
				}

				.input {
					width: 80px;
					height: 30px;
					line-height: 30px;
					background: #FFFFFF;
					margin-left: 10px;
					text-align: center;
					border: none;
				}
			}
		}

		.total {
			height: 44px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-size: 15px;
				font-weight: bold;
				color: #333333;
			}

			.price {
				font-weight: 400;
				color: #0f114a;
			}
		}


	}

	.select-active {
		position: relative;
	}

	.select-active:after {
		background-image: url("../../assets/images/design/select@2x.png");
		background-size: 100%;
		width: 13px;
		height: 13px;
		position: absolute;
		right: 5px;
		top: 5px;
		content: "";
	}

	.table-wrap {

		.input-box {
			width: 166px;
			height: 60px;
			float: left;
			display: flex;
			align-items: center;
			padding: 20px 10px;

			.input-title {
				width: 60px;
				font-size: 14px;
				font-weight: bold;
				color: #000000;
				text-align: right;
			}

			.input {
				width: 80px;
				height: 30px;
				line-height: 30px;
				background: #FFFFFF;
				margin-left: 10px;
				text-align: center;
			}
		}
	}
	.upload-list {
		display: inline-block;
		margin-right: 10px;

		.profile-image-wrap {
			display: inline-block;
			position: relative;
			.profile-image-icon {
				position: absolute;
				top: -10px;
				right: 0;
				font-size: 20px;
				z-index: 100;
			}
		}

		img {
			margin: 0 10px;
		}
	}
	.pay {
		width: 300px;
		height: 44px;
		line-height: 44px;
		background: #0f114a;
		opacity: 1;
		border-radius: 2px;
		text-align: center;
		font-size: 16px;
		font-weight: bold;
		color: #edd4ac;
		margin: 30px auto 30px ;
		cursor: pointer;
	}
	.ivu-upload {
		display: inline-block;
	}

</style>
